import { render, staticRenderFns } from "./purchasePage.vue?vue&type=template&id=a3dcefc6&scoped=true"
import script from "./purchasePage.vue?vue&type=script&lang=js"
export * from "./purchasePage.vue?vue&type=script&lang=js"
import style0 from "./purchasePage.vue?vue&type=style&index=0&id=a3dcefc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3dcefc6",
  null
  
)

export default component.exports